import { useTranslate } from '@ur-solutions/react-hooks'

export const BetaChip: React.FC = () => {
  const texts = useTranslate({ beta: 'settings.generation-preview.beta' })
  return (
    <span className="inline-flex items-center gap-2 rounded-full border border-amber-300 bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-900">
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {texts.beta}
    </span>
  )
}
